export const BUYER_INTENTIONS = []
export const CONTACT_DEFAULT_MESSAGE = 'Me interesa este vehículo'
